import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatChip } from '@angular/material/chips';

import { AdvertisementListItemDto, CategoryDto } from '../../api';

@Component({
  selector: 'app-advertisement-chips',
  imports: [MatChip],
  templateUrl: './advertisement-chips.component.html',
  styleUrl: './advertisement-chips.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvertisementChipsComponent {
  advertisement = input.required<AdvertisementListItemDto>();
  categories = input.required<Map<number, CategoryDto>>();
}
